<template>
  <el-dialog
    title="提示"
    :visible.sync="dialogVisible"
    @close="close"
    width="900px"
  >
    <el-input
      v-model="form.sn"
      placeholder="请输入tbox编号"
      style="width: 210px; display: inline-block; margin-left: 10px"
      clearable
    ></el-input>
    <el-button type="primary" style="margin-left: 16px" @click="initTableData()"
      >搜索</el-button
    >
    <el-form ref="form" :model="form" label-width="70px">
      <el-row :gutter="20">
        <el-col :span="7">
          <!-- <el-form-item label="车辆品牌">
                  <el-select v-model="form.BrandVal" clearable @change="BrandHandel" @clear="clearType" placeholder="请选择品牌">
                    <el-option
                      v-for="item in options.Brand"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item> -->
        </el-col>
        <el-col :span="3">
          <!-- <el-button type="primary" >搜索</el-button> -->
        </el-col>
      </el-row>
      <el-row :gutter="20" style="padding: 0 20px">
        <el-table
          :data="tableData"
          highlight-current-row
          @current-change="handleCurrentChange"
          height="300px"
          style="width: 100%"
        >
          <el-table-column type="index" label="序号" align="center">
          </el-table-column>
          <el-table-column prop="tbox_num" label="tbox编号" align="center">
          </el-table-column>
          <!-- <el-table-column
                  prop="frame_num"
                  label="车架号"
                  align="center"
                  >
                </el-table-column> -->
        </el-table>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="submitHandel">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { GetTboxdata, unBindData } from '@/api/tbox'
export default {
  props: ['companyId'],
  data () {
    return {
      dialogVisible: true,
      param: {
      },
      tableData: [],
      form: { sn: '' },
    }
  },
  created () {
    this.initTableData()
  },
  methods: {
    clearType () {
    },
    close () {
      this.$parent.dialogVisible = false
    },
    submitHandel () {
      this.close()
      this.$emit('parent', this.form)
    },
    initTableData () {
      let params = JSON.parse(JSON.stringify(this.form))
      params.companyId = this.companyId
      unBindData(params).then(res => {
        this.tableData = res.data.content
      })
    },
    handleCurrentChange (val) {
      this.form.tbox_num = val.tbox_num
    },
  }
}
</script>

<style>
</style>
